import { __read } from "tslib";
import React from "react";
import moment from "moment";
import Table, { CellStatus } from "./BaseTable";
import { useTranslation } from "../../i18n";
import { noop } from "../../_util/noop";
import { getNow, isAfter, isBefore, isSame } from "../../datepicker/util";
export function MonthTable(_a) {
    var current = _a.current, _b = _a.onCurrentChange, onCurrentChange = _b === void 0 ? noop : _b, range = _a.range, _c = _a.onSelect, onSelect = _c === void 0 ? noop : _c, disabledMonth = _a.disabledMonth, _d = _a.onTypeChange, onTypeChange = _d === void 0 ? noop : _d, _e = _a.cellStatus, cellStatus = _e === void 0 ? function () { return CellStatus.Common; } : _e, hideCaption = _a.hideCaption, dateRender = _a.dateRender;
    var t = useTranslation();
    var year = current.year();
    var now = getNow(current);
    function genTable() {
        return [
            [0, 1, 2, 3],
            [4, 5, 6, 7],
            [8, 9, 10, 11],
        ];
    }
    function renderYear() {
        return (React.createElement("a", { className: "op-item", onClick: function () { return onTypeChange("year"); } }, current.format(t.yearFormat)));
    }
    var _f = __read(range || [null, null], 2), rangeMin = _f[0], rangeMax = _f[1];
    function isValid(date) {
        if (moment.isMoment(rangeMin) && isAfter(rangeMin, date, "month")) {
            return false;
        }
        if (moment.isMoment(rangeMax) && isBefore(rangeMax, date, "month")) {
            return false;
        }
        return disabledMonth(date);
    }
    return (React.createElement(Table, { type: "month", caption: !hideCaption && renderYear(), jumperOptions: {
            onNext: function () { return onCurrentChange(moment(current).add(1, "year")); },
            onPrev: function () { return onCurrentChange(moment(current).subtract(1, "year")); },
            onCurrent: function () { return onCurrentChange(now); },
            isCurrent: isSame(current, now, "year"),
            nextDisabled: moment.isMoment(rangeMax) &&
                isBefore(rangeMax, moment(current)
                    .set({ month: 0, date: 1 })
                    .add(1, "year"), "month"),
            prevDisabled: moment.isMoment(rangeMin) &&
                isAfter(rangeMin, moment(current)
                    .set({ month: 0, date: 1 })
                    .subtract(1, "day"), "month"),
            nextTitle: t.nextYear,
            prevTitle: t.prevYear,
            curTitle: t.curYear,
        } }, genTable().map(function (row, index) { return (React.createElement(Table.Row, { key: index }, row.map(function (month) {
        var m = moment(current).set({
            year: year,
            month: month,
            date: 1,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
        return (React.createElement(Table.Cell, { key: month, name: moment.monthsShort(month), value: m, onSelect: onSelect, isNow: isSame(m, now, "month"), status: cellStatus(m), disabled: !isValid(m), calendarType: "month", dateRender: dateRender }));
    }))); })));
}
MonthTable.displayName = "MonthTable";
//# sourceMappingURL=MonthTable.js.map